// extracted by mini-css-extract-plugin
export default {"ebanner":"ci-z"};